import { calculatePercentage } from '@/utils/helpers';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import styles from './insights-pie-chart.module.scss';
import {
  Insight,
  InsightLanguageDistribution,
} from '@/services/dashboard-service/dashboard.service.types';
import ChartLabel from './chart-label/chart-label';

interface InsightsPieChartProps {
  data: Insight | InsightLanguageDistribution;
  sumOfData: number;
}

export default function InsightsPieChart({ data, sumOfData }: InsightsPieChartProps) {
  const getValue = (
    value: number | null | { count: number; language_flag_url: string | null }
  ): number | null => {
    if (typeof value === 'object' && value !== null && 'count' in value) {
      return value.count;
    }
    return value;
  };

  const pieChartData = Object.keys(data)?.map((key) => {
    const numericValue = getValue(data[key]);
    const value = numericValue ?? 0;
    return {
      value,
      label: `${calculatePercentage(value, sumOfData)}%`,
    };
  });

  const colorClasses = [styles.purple1, styles.purple2, styles.purple3, styles.red1, styles.red2];

  return (
    <ResponsiveContainer maxHeight={300} aspect={1} className={styles.container}>
      <PieChart width={300} height={300}>
        <Pie
          data={pieChartData}
          dataKey="value"
          outerRadius="100%"
          labelLine={false}
          label={ChartLabel}
        >
          {Object.keys(data).map((key, index) => {
            return <Cell key={`cell-${key}`} fill={colorClasses[index]} />;
          })}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
}
